import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeOne from "./pages/HomeOne";
import About from "./pages/About";
import Overview from "./pages/Navbar/Overview";
import BoardDirectors from "./pages/Navbar/BoardOfDirectors";
import FriendsOfBeads from "./pages/Navbar/FriendsOfBeads";
import Press from "./pages/Navbar/press";
import Mentorship from "./pages/Navbar/mentorship";
import BeadingGroups from "./pages/Navbar/BeadingGroups";
import ChangemakerProjects from "./pages/Navbar/ChangemakerProjects";
import OverviewTab from "./pages/Navbar/OverviewTab";
import InternsProgram from "./pages/Navbar/InternsProgram";
import ComingOfAge from "./pages/Navbar/ComingOfAge";
import EstherStory from "./pages/EstherStory";
import TeacherTraining from "./pages/Navbar/TeacherTraining";
import LibraryDevelopment from "./pages/Navbar/LibraryDevelopment";
import SchoolSponsorships from "./pages/Navbar/SchoolSponsorships";
import FamineRelief from "./pages/Navbar/FamineRelief";
import CarolSuccessStory from "./pages/Navbar/CarolSuccessStory";
import SuccessStory from "./pages/Navbar/SuccessStories";
import TembeaOverview from "./pages/Navbar/TembeaOverview";
import FundingNeeds from "./pages/Navbar/FundingNeeds";
import DonationsAndGifts from "./pages/Navbar/DonationsAndGifts";
import SponsorsTrips from "./pages/Navbar/SponsorsTrips";
import News from "./pages/Navbar/News";
import BeadsConceptNote from "./components/NewsComponents/BeadsConceptNote";
import NewsDetail from "./components/NewsComponents/NewsDetail";
import Contact from "./pages/Contact";
import Donate from "./pages/Navbar/Donate";
import Missing from "./components/Missing";
import AOS from "aos";
import "aos/dist/aos.css";
import ScrollToTop from './hooks/ScrollToTop';
import { useEffect } from "react";
import BackToTop from "react-scroll-to-top";
import './App.css';
import './index.scss';

const App = () => {
  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: "ease",
      once: true,
    });
    AOS.refresh();
  }, []);

  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path='/' element={<HomeOne />} />
        <Route path='/about' element={<About />} />
        <Route path='/overview' element={<Overview />} />
        <Route path='/board-of-directors' element={<BoardDirectors />} />
        <Route path='/friends-of-beads' element={<FriendsOfBeads />} />
        <Route path='/press' element={<Press />} />
        <Route path='/mentorship-program' element={<Mentorship />} />
        <Route path='/beading-groups' element={<BeadingGroups />} />
        <Route path='/changemaker-projects' element={<ChangemakerProjects />} />
        <Route path='/overview-tab' element={<OverviewTab />} />
        <Route path='/interns-program' element={<InternsProgram />} />
        <Route path='/coming-of-age' element={<ComingOfAge />} />
        <Route path='/esthers-story' element={<EstherStory />} />
        <Route path='/teachers-training' element={<TeacherTraining />} />
        <Route path='/library-development' element={<LibraryDevelopment />} />
        <Route path='/school-sponsorships' element={<SchoolSponsorships />} />
        <Route path='/famine-relief' element={<FamineRelief />} />
        <Route path='/carol-success-story' element={<CarolSuccessStory />} />
        <Route path='/success-stories' element={<SuccessStory />} />
        <Route path="/tembea-overview" element={<TembeaOverview />} />
        <Route path="/funding-needs" element={<FundingNeeds />} />
        <Route path="/donations-and-alternative-gifts" element={<DonationsAndGifts />} />
        <Route path="/sponsors-trips" element={<SponsorsTrips />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/beads-concept-note" element={<BeadsConceptNote />} />
        {/* <Route path="/news/:id" element={<NewsDetail />} /> */}
        <Route path="/news/:category/:titlewithid" element={<NewsDetail />} />
        {/* <Route path="/news/:category/:title/:id" element={<NewsDetail />} /> */}
        {/* <Route path="/news/:category/:title-:id" element={<TestComponent />} /> */}
        <Route path='/contact' element={<Contact />} />
        <Route path='/donate' element={<Donate />} />
        <Route path="*" element={<Missing />} />
      </Routes>
      <BackToTop smooth color='#246BFD' />
    </BrowserRouter>
  );
}

export default App;
